import type { SectionLocale } from '../types'

export const LOCATION_LOCALE: SectionLocale = [
  [
    'location_country_placeholder',
    {
      ru: 'Выберите страну',
      en: 'Choose country',
    },
  ],
  [
    'location_countries_placeholder',
    {
      ru: 'Выберите страны',
      en: 'Choose countries',
    },
  ],
  [
    'location_exclude',
    {
      ru: 'Не показывать для:',
      en: 'Do not show for:',
    },
  ],
  [
    'location_country',
    {
      ru: 'Страна',
      en: 'Country',
    },
  ],
  [
    'location_city',
    {
      ru: 'Город',
      en: 'City',
    },
  ],
  [
    'location_office',
    {
      ru: 'Офис',
      en: 'Office',
    },
  ],
  [
    'location_select_all_offices',
    {
      ru: 'Выбрать все офисы в этой локации',
      en: 'Select all offices in this location',
    },
  ],
  [
    'location_add_country',
    {
      ru: 'Добавить страну',
      en: 'Add country',
    },
  ],
  [
    'location_title',
    {
      ru: 'Офисы (локации)',
      en: 'Offices (locations)',
    },
  ],
  [
    'location_delete_question',
    {
      ru: 'Удалить локацию?',
      en: 'Delete location?',
    },
  ],
  [
    'location_select_error',
    {
      ru: 'Локация уже выбрана',
      en: 'Location already selected',
    },
  ],
  [
    'location_error_select_city',
    {
      ru: 'Выберите город',
      en: 'Select city',
    },
  ],
  [
    'location_error_select_office',
    {
      ru: 'Выберите офис',
      en: 'Select office',
    },
  ],
  [
    'location_all',
    {
      ru: 'Все локации',
      en: 'All locations',
    },
  ],
  [
    'location_all_countries',
    {
      ru: 'Все страны',
      en: 'All countries',
    },
  ],
  [
    'location_all_cities',
    {
      ru: 'Все города',
      en: 'All cities',
    },
  ],
  [
    'location_all_offices',
    {
      ru: 'Все офисы',
      en: 'All offices',
    },
  ],
]
